import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const GetAllFavourites = {
  name: 'getAllFavourites',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: [
        'Company Name',
        'Email',
        'Industry',
        'Invited Displays',
        'Invited Zone',
        'Active Ads',
        'Favorite',
    ],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },
    getRecivedAllAdvsList(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        data: payload.data,
        totalCount: payload.totalCount,
      };
    },

    getReceived(state, payload) {
      const arr = [];
      payload.data.forEach((element) => {
        arr.push({
          id: element.favouriteid,
          companyName: element.org_name,
          email: element.email || '-',
          industry: element?.industry ? element.industry : 'No Industry',
          displays: element.displays,
          campaigns: element.campaigns,
          zones: element.zones,
          isFavourite:element.isFavourite
        });
      });
     return {
        ...state,
        data: arr,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },
    getReceivedAllAdvs(state, payload) {
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({userOrgId, page, size, search, selectedFilters}) {
      try {
        this.getRequested();
        let url = `savvy/favourite?page=${page}&size=${size}&userOrgId=${userOrgId}`;
        if (search) {
          url = url + `&search="${search}"`;
        }
        if (selectedFilters?.industry?.length) {
          selectedFilters.industry.forEach(ind => {
            url += `&industry[]=${encodeURIComponent(ind)}`;
          });
        }
        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data?.count,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetAllFavourites;